import React, { Component } from 'react';
import Util from '../../util.js';
import NavigatorMain from '../NavigatorMain';

import { hashHistory } from 'react-router';
import {superFundCodeFee } from '../../common';

// import { setStorage, getStorage, urlAllBase, isLoginAndRealName } from '../../CommonVar';


/*止盈往期表现*/
export default class HistoryPerformance extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingFlag:true,
    }
  }
  componentWillMount() {
  }
  handleCallback(){

  }
  componentDidMount(){
    let { dispatch } = this.props;
  }
  componentWillUnmount() {
    
  }
  goBack(){
    hashHistory.goBack();
  }
  render(){
    let superFundCode = this.props.location.state && this.props.location.state.superFundCode
    console.log(superFundCode);
    return(
      <div className="container">
        <NavigatorMain>
          <div className="header blue-bg">
            <div style={{ WebkitFlex:1 }}><span className="headerLeftBtn" onClick={ ()=> this.goBack() }></span></div>
            <div style={{ WebkitFlex:2, textAlign:'center', fontSize:"0.3rem" }}> 往期表现 </div>
            <div style={{ WebkitFlex:1, textAlign:'right', fontSize:"0.28rem", paddingRight:'13px' }}></div>    
          </div>
        </NavigatorMain>

        <div className="content">
          <div className="Performance_bg"></div>
          <div className="eq_zyztDetail_title" style={{WebkitFlexDirection: "row", display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center",marginTop:'-2.9rem'}}>
              <div>组合名称</div>
              <div>达标天数</div>
          </div>
          <div className="zyztDetail_content" >
            {
              this.props.location.state.reportList ?
              this.props.location.state.reportList.map((item,index)=>{
              return(
                <div key={index+'_item'} className="Performance_item">
                   <div>{item.fundName}</div>
                   <div>{item.status}</div>
                </div>
              )
            })
            :null
            }
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/fundDetail/HistoryPerformance.js